export const blockIconsActionManageAccounts = (
	<span className='material-symbols-outlined'>manage_accounts</span>
);
